"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../../utils/index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// utils
// styles
// import injectSheet from 'react-jss';
// import styles from '../../../../material/tables/listtable/thead/thead_styles';

/* ========== ~~~~~~~~~~ EXPORT : TABLE : THEAD ~~~~~~~~~~ ========== */


var _default = function _default(props) {
  return _react.default.createElement("thead", {
    className: "thead ".concat((0, _index.generateClasses)(props))
  }, props.children);
};

exports.default = _default;